// Layout of queryKeys.playerStats.progress:
// ['playerStats', 'progress', playerId, sportId, genericSportId, role, range, timezone]
// Everything before `range` identifies the series; range and timezone only
// re-bucket it.
const SERIES_IDENTITY_LENGTH = 6

/**
 * True when two progress query keys chart the same series (same player, sport,
 * generic sport and role) and differ at most in range or timezone — the only case where the
 * previous chart may stay on screen while the next one loads.
 */
export const sameProgressSeries = (
  previousKey: readonly unknown[],
  nextKey: readonly unknown[]
): boolean =>
  previousKey.length === nextKey.length &&
  nextKey.length > SERIES_IDENTITY_LENGTH &&
  nextKey
    .slice(0, SERIES_IDENTITY_LENGTH)
    .every((part, index) => part === previousKey[index])
